
import { isScanningAvailable } from '@/lib/ui-utils';
import { PreviewData, ScreenCaptureServiceEventType } from '@/services/screen-capture/models';
import { Component, Vue, Prop } from 'vue-property-decorator';
import screenCaptureService from '../services/screen-capture/screen-capture.service';
import SaplingScreenCapturePreview from './SaplingScreenCapturePreview.vue';

@Component({ components: { SaplingScreenCapturePreview } })
export default class SaplingScreenCapture extends Vue {
  @Prop({ type: Boolean }) isHidden: boolean;
  @Prop({ type: Boolean }) isDisabled: boolean;
  @Prop({ type: Boolean }) skipScannerGuide: boolean;

  isDialogOpen = false;
  showPreview = false;
  isScanning = false;
  isInitializing = false;
  shouldDisplayScreenCaptureButton = false;

  created() {
    this.shouldDisplayScreenCaptureButton = isScanningAvailable();
  }

  mounted() {
    screenCaptureService.addEventListener(this.onScreenCaptureServiceEvent);
  }

  handleScanClick() {
    if (this.skipScannerGuide) {
      this.startCapturing();
    } else {
      this.isDialogOpen = true;
    }
  }

  startCapturing() {
    screenCaptureService.startCapturing();
  }

  stopCapturing() {
    screenCaptureService.stopCapturing();
  }

  setPreview(regionIndex: number, imgData: ImageData) {
    (this.$refs.preview as SaplingScreenCapturePreview)?.setPreview(regionIndex, imgData);
  }

  onScreenCaptureServiceEvent(eventType: ScreenCaptureServiceEventType, data?: string | PreviewData) {
    if (eventType === 'INITIALIZING') {
      this.isInitializing = true;
    } else if (eventType === 'STARTED') {
      this.isInitializing = false;
      this.isScanning = true;
      this.$emit('started-scanning');
    } else if (eventType === 'STOPPED') {
      this.isInitializing = false;
      this.isScanning = false;
      this.$emit('stopped-scanning');
    } else if (eventType === 'SAPLING-FOUND') {
      this.$emit('sapling-scanned', data);
    } else if (eventType === 'PREVIEW') {
      const previewData = data as PreviewData;
      this.setPreview(previewData.regionIndex, previewData.imgData);
    }
  }
}
